import styled from 'styled-components';

import theme from '@theme/FolxTheme';

const MembershipContainer = styled.div`
	align-items: center;
	display: flex;
	flex-flow: column;
	padding-top: ${theme.spacing.md};
	padding-bottom: ${theme.spacing.xxxl};
	padding-left: ${theme.spacing.lg};
	padding-right: ${theme.spacing.lg};
	min-height: 100%;
	width: 100%;
	max-width: 68rem;

	@media ${theme.responsive.breakpoints.tablet} {
		padding-left: 0;
		padding-right: 0;
	}
`;

export default MembershipContainer;
